import { useGT } from 'gt-react';
import type { CompanyListItem } from '@erp/rpc';
import {
  companyOptionPrimary,
  displayCompanyCode,
  formatVendorNumbers,
  pricelistVendorName,
} from './companyPickerDisplay';

interface Props {
  company: CompanyListItem;
  /** Item Master: lead the row with the 5-digit vendor#. */
  vendorFirst?: boolean;
}

/** A company row's content, with the codes that tell two similar names apart. */
export function CompanyOption({ company, vendorFirst = false }: Props) {
  const gt = useGT();

  return (
    <div className="min-w-0">
      {vendorFirst ? (
        <VendorFirstLabels company={company} />
      ) : (
        <>
          <span className="block truncate">{company.name}</span>
          <span className="block text-xs text-muted-foreground">
            {gt('Company Code', {
              context: 'company code shown in the company selector',
            })}
            {`: ${company.originId ?? '—'}`}
          </span>
          <span className="block text-xs text-muted-foreground">
            {gt('Vendor Number', {
              context: 'vendor number shown in the company selector',
            })}
            {`: ${company.vendorNumbers.join(', ') || '—'}`}
          </span>
        </>
      )}
    </div>
  );
}

function VendorFirstLabels({ company }: { company: CompanyListItem }) {
  const gt = useGT();
  const vendorLabel = formatVendorNumbers(company.vendorNumbers);
  const primary = companyOptionPrimary(company);
  const companyCode = displayCompanyCode(company.originId);

  return (
    <>
      <span className="block truncate font-medium">{primary}</span>
      {vendorLabel !== '' && (
        <span className="block truncate text-xs text-muted-foreground">
          {pricelistVendorName(company.name)}
        </span>
      )}
      {companyCode !== null && (
        <span className="block text-xs text-muted-foreground">
          {gt('Company Code', {
            context: 'company code shown in the company selector',
          })}
          {`: ${companyCode}`}
        </span>
      )}
      {vendorLabel === '' && (
        <span className="block text-xs text-muted-foreground">
          {gt('Vendor Number', {
            context: 'vendor number shown in the company selector',
          })}
          {`: ${vendorLabel || '—'}`}
        </span>
      )}
    </>
  );
}
